exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group_body {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .group_body .field_lock {\n    cursor: not-allowed; }\n  .group_body .dialogForm {\n    display: contents; }\n  .group_body .list_item {\n    width: 100%; }\n\nbutton {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  -ms-flex-item-align: end;\n      align-self: flex-end; }\n\n.margin-card {\n  margin: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/edit-propertie-dialog/save-propertie-dialog/save-propertie-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/edit-propertie-dialog/save-propertie-dialog/save-propertie-dialog.component.scss
// module chunks = main